import { useEffect } from 'react';
import { Link, useLocation } from 'react-router';
import {
  Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarHeader,
  SidebarMenu, SidebarMenuButton, SidebarMenuItem, SidebarRail, useSidebar,
} from '@/components/ui/sidebar';
import { AppSwitcher } from './app-switcher';
import { GLOBAL_NAV, type NavItem } from './nav';

function NavLinks({ items, isActive, href }: { items: NavItem[]; isActive(n: NavItem): boolean; href(n: NavItem): string }) {
  return (
    <SidebarMenu>
      {items.map((n) => (
        <SidebarMenuItem key={n.to}>
          <SidebarMenuButton asChild tooltip={n.label} isActive={isActive(n)}>
            <Link to={href(n)}><n.icon /> <span>{n.label}</span></Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  );
}

export function AppSidebar() {
  const { pathname, search } = useLocation();
  const { isMobile, setOpenMobile } = useSidebar();

  // On phones the sidebar is a sheet over the page: close it once a link has navigated.
  useEffect(() => { if (isMobile) setOpenMobile(false); }, [pathname, search, isMobile, setOpenMobile]);

  const globalActive = (n: NavItem) => (n.to === '/' ? pathname === '/' || pathname.startsWith('/apps') : pathname.startsWith(n.to));

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <AppSwitcher />
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Platform</SidebarGroupLabel>
          <SidebarGroupContent>
            <NavLinks items={GLOBAL_NAV} isActive={globalActive} href={(n) => n.to} />
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarRail />
    </Sidebar>
  );
}
